import { Image } from '#components/Image/Image';
import { BreakpointMedia } from '#cutils/breakpoints/media';
import type { MediaContextPlaybackStatus } from '#cutils/context/MediaContext';
import { useDefaults } from '#cutils/hooks/useDefaults';
import { notNullOrUndefined } from '#cutils/misc/notNullOrUndefined';

import { HERO_IMAGE_SIZES } from '../Sections/ArticleHeroMedia';

import styles from './ArticleModuleHeroSidebar.module.scss';
import { ArticleModuleHeroSidebarSectionCopyright } from './ArticleModuleHeroSidebarSectionCopyright';
import { ArticleModuleHeroSidebarSectionTags } from './ArticleModuleHeroSidebarSectionTags';
import type { ArticleModuleHeroSidebarFragment } from './__generated__/ArticleModuleHeroSidebar.generated';

type Props = {
	article: ArticleModuleHeroSidebarFragment;
	mediaPlaybackStatus: MediaContextPlaybackStatus;
};

export function ArticleModuleHeroSidebar({ article, mediaPlaybackStatus }: Props) {
	const { fallbackTeaserModule } = useDefaults();
	const [teaserModule = fallbackTeaserModule] = article.teaserModule.nodes;

	const thumbnail = article?.teaserModule?.nodes?.[0]?.thumbnail ?? fallbackTeaserModule.thumbnail;

	const tags = article.tags2.nodes.filter(notNullOrUndefined);

	return (
		<BreakpointMedia greaterThanOrEqual="lg">
			{(className, renderChildren) => {
				return (
					<div className={`${className} ${styles.wrapper}`}>
						{renderChildren ? (
							<>
								<Image className={styles.imageRoot} src={thumbnail?.url} alt={thumbnail?.altText ?? ''} sizes={HERO_IMAGE_SIZES} />

								<div className={styles.meta}>
									{!!teaserModule && (
										<ArticleModuleHeroSidebarSectionCopyright mediaPlaybackStatus={mediaPlaybackStatus} teaserModule={teaserModule} />
									)}

									{tags.length > 0 && <ArticleModuleHeroSidebarSectionTags tags={tags} />}
								</div>
							</>
						) : null}
					</div>
				);
			}}
		</BreakpointMedia>
	);
}
